// ConfirmDeleteModal.jsx
import React from "react";
import { Modal } from "@mui/material";
import alert_img from "../../assets/images/alert-image.svg";

function ConfirmDeleteModal({ open, onClose, onConfirm, name, role = "advisor" }) {

  // ── Derive content based on role ──
  const content = (() => {
    switch (role) {

      // ── Assign new HOD ──
      // ── Assign advisor ──
      case "advisor":
        return {
          title: null,
          message: (
            <>
              Are you sure you want to assign <strong>"{name}"</strong> as an Advisor?
            </>
          ),
          confirmLabel: "Assign Advisor",
        };

      // ── Assign learning specialist ──
      case "specialist":
        return {
          title: null,
          message: (
            <>
              Are you sure you want to assign <strong>"{name}"</strong> as a Learning Specialist?
            </>
          ),
          confirmLabel: "Assign Learning Specialist",
        };

      // ── Remove advisor ──
      case "remove_advisor":
        return {
          title: "Remove Advisor",
          message: (
            <>
              Removing <strong>{name}</strong> from this role, advisor will result in loss of assigned student data. Do you want to proceed?
            </>
          ),
          confirmLabel: "Remove Advisor",
        };
      case "hod":
        return {
          title: null, // no title for HOD assign (matches design)
          message: (
            <>
              Are you sure you want to assign <strong>"{name}"</strong> HOD?
              <br />
              <span style={{ fontSize: 13, color: "#6b7280" }}>
                By selecting HOD the Learning Specialist or Advisor titles will be replaced with HOD
                and the tasks associated with those roles will no longer be accessible.
              </span>
            </>
          ),
          confirmLabel: "Assign HOD",
        };

      // ── Update existing HOD with a new teacher ──
      case "update hod":
        return {
          title: null,
          message: (
            <>
              Are you sure you want to update <strong>"{name}"</strong> HOD?
              <br />
              <span style={{ fontSize: 13, color: "#6b7280" }}>
                By selecting HOD the Learning Specialist or Advisor titles will be replaced with HOD
                and the tasks associated with those roles will no longer be accessible.
              </span>
            </>
          ),
          confirmLabel: "Assign HOD",
        };

      // ── Remove HOD (edit modal, no teacher selected) ──
      case "remove hod":
        return {
          title: null,
          message: "Are you sure you want to remove HOD from this department",
          confirmLabel: "Remove HOD",
        };

      // ── Remove student from advisor ──
      case "student":
        return {
          title: "Remove Student",
          message: (
            <>
              Are you sure you want to remove <strong>{name}</strong> from this advisor's assigned list
            </>
          ),
          confirmLabel: "Remove Student",
        };

      // ── Remove student from learning specialist ──
      case "ls_student":
        return {
          title: "Remove Student",
          message: (
            <>
              Are you sure you want to remove <strong>{name}</strong> from this Learning Specialist's assigned list
            </>
          ),
          confirmLabel: "Remove Student",
        };

      // ── Remove learning specialist ──
      case "ls":
        return {
          title: "Remove Learning Specialist",
          message: (
            <>
              Removing <strong>{name}</strong> from this role, learning specialist will result in loss of assigned student data. Do you want to proceed?
            </>
          ),
          confirmLabel: "Remove Learning Specialist",
        };

      default:
        return {
          title: "Confirm",
          message: "Are you sure?",
          confirmLabel: "Confirm",
        };
    }
  })();

  return (
    <Modal open={open} onClose={onClose}>
      <div style={{
        width: window.innerWidth >= 1024 ? "50%" : "90%",
        maxWidth: window.innerWidth < 1024 ? "400px" : "none",
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        background: "#fff", borderRadius: 16, padding: 32,
        boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
        display: "flex", flexDirection: "column", alignItems: "center", gap: 16,
        overflow: "auto", maxHeight: "90vh", 
      }}>

        {/* Icon */}
        <div style={{ borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <img src={alert_img} alt="alert" />
        </div>

        {/* Title — only shown when content.title is set */}
        {content.title && (
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600, color: "#111827" }}>
            {content.title}
          </h3>
        )}

        {/* Message */}
        <p style={{
          margin: 0, fontSize: 15, color: "#111827",
          textAlign: "center", lineHeight: 1.6,
        }}>
          {content.message}
        </p>

        {/* Buttons */}
        <div style={{ display: "flex", gap: 12, width: "100%", marginTop: 8 }}>
          <button
            onClick={onClose}
            style={{
              flex: 1, padding: "10px 0", borderRadius: 8,
              border: "1.5px solid #e5e7eb", background: "#fff",
              fontSize: 14, fontWeight: 500, color: "#374151", cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1, padding: "10px 0", borderRadius: 8,
              border: "none", background: "#0068FF",
              fontSize: 14, fontWeight: 500, color: "#fff", cursor: "pointer",
            }}
          >
            {content.confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmDeleteModal;